import React, {
    useState
} from 'react';


import {
    useSelector
} from 'react-redux';


// css
import {

    ContenedorAgendadas,

    BuscadorAgendadas,
    IconoBuscarAgendadas,
    InputBuscarAgendadas,

    TablaAgendadas,
    EncabezadoAgendadas,
    TituloColumnaAgendada,

    ListaAgendadas,
    FilaAgendada,

    LeccionAgendada,
    EjercitacionAgendada,
    EstadoAgendada,

    SinAgendadas

} from '../Css/StyledActividadesDomicilio';



const SeleccionarActividadesAgendadas = () => {


    const [
        busqueda,
        setBusqueda
    ] = useState(
        ''
    );


    const infoActividadesAgendadas =
        useSelector(
            (state) =>
                state.informacion.info_actividades_agendadas
        );


    /*
    ====================================
    LISTA SEGURA
    ====================================
    */

    const actividadesAgendadas =
        Array.isArray(
            infoActividadesAgendadas
        )
            ? infoActividadesAgendadas
            : [];



    /*
    ====================================
    BUSCADOR
    ====================================

    Solo filtra visualmente.
    No modifica Redux ni backend.
    ====================================
    */

    const busquedaNormalizada =
        busqueda
            .trim()
            .toLowerCase();


    const actividadesFiltradas =
        actividadesAgendadas.filter(
            item => {


                if (
                    !busquedaNormalizada
                ) {

                    return true;

                }


                const textoBuscar =
                    `${item.sesion || ''} ${item.ejercitacion || ''}`
                        .toLowerCase();


                return textoBuscar.includes(
                    busquedaNormalizada
                );

            }
        );



    return (

        <ContenedorAgendadas>


            {/*
            ====================================
            BUSCADOR
            ====================================
            */}


            <BuscadorAgendadas>


                <IconoBuscarAgendadas>

                    ⌕

                </IconoBuscarAgendadas>


                <InputBuscarAgendadas

                    type="text"

                    value={
                        busqueda
                    }

                    placeholder={
                        "Buscar por lección o ejercitación..."
                    }

                    onChange={
                        e =>
                            setBusqueda(
                                e.target.value
                            )
                    }

                />


            </BuscadorAgendadas>


            {/*
            ====================================
            LISTADO
            ====================================
            */}


            <TablaAgendadas>


                <EncabezadoAgendadas>


                    <TituloColumnaAgendada>

                        Fecha creación

                    </TituloColumnaAgendada>


                    <TituloColumnaAgendada>

                        Fecha asignada

                    </TituloColumnaAgendada>


                    <TituloColumnaAgendada>

                        Lección

                    </TituloColumnaAgendada>


                    <TituloColumnaAgendada>

                        Fecha expiración

                    </TituloColumnaAgendada>


                    <TituloColumnaAgendada>

                        Progreso

                    </TituloColumnaAgendada>


                    <TituloColumnaAgendada>

                        Fecha ejercitación

                    </TituloColumnaAgendada>


                    <TituloColumnaAgendada>

                        Ejercitación

                    </TituloColumnaAgendada>


                </EncabezadoAgendadas>


                <ListaAgendadas>


                    {
                        actividadesFiltradas.length ===
                        0
                            ?

                            <SinAgendadas>

                                {
                                    busquedaNormalizada
                                        ?
                                        "No hay actividades agendadas que coincidan con la búsqueda."
                                        :
                                        "Todavía no hay actividades agendadas."
                                }

                            </SinAgendadas>

                            :

                            actividadesFiltradas.map(
                                (
                                    item,
                                    index
                                ) => {


                                    const estadoNormalizado =
                                        String(
                                            item.estado_ejercicio ||
                                            ''
                                        )
                                            .trim()
                                            .toLowerCase();


                                    const completo =
                                        estadoNormalizado ===
                                        'completado';


                                    return (

                                        <FilaAgendada

                                            key={
                                                `${item.sesion}-${index}`
                                            }

                                        >


                                            <div>

                                                {
                                                    item.fecha_registro ||
                                                    '—'
                                                }

                                            </div>


                                            <div>

                                                {
                                                    item.fecha_agendada ||
                                                    '—'
                                                }

                                            </div>


                                            <LeccionAgendada>

                                                {
                                                    item.sesion ||
                                                    '—'
                                                }

                                            </LeccionAgendada>


                                            <div>

                                                {
                                                    item.fecha_expiracion ||
                                                    '—'
                                                }

                                            </div>


                                            <div>


                                                <EstadoAgendada

                                                    completo={
                                                        completo
                                                    }

                                                >

                                                    {
                                                        item.estado_ejercicio ||
                                                        'Pendiente'
                                                    }

                                                </EstadoAgendada>


                                            </div>


                                            <div>

                                                {
                                                    item.fecha_ejercitacion ||
                                                    '—'
                                                }

                                            </div>


                                            <EjercitacionAgendada>

                                                {
                                                    item.ejercitacion ||
                                                    '—'
                                                }

                                            </EjercitacionAgendada>


                                        </FilaAgendada>

                                    );

                                }
                            )
                    }


                </ListaAgendadas>


            </TablaAgendadas>


        </ContenedorAgendadas>

    );

};


export default SeleccionarActividadesAgendadas;